import React, { Component } from 'react'
import { Authenticated, GET_LIST, UPDATE } from 'react-admin'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Snackbar from '@material-ui/core/Snackbar'
import CertificationIcon from '@material-ui/icons/CheckCircle';
import { withStyles } from '@material-ui/core/styles';
import { TextInput, SelectInput, ReferenceSelectInput } from '../Inputs'
import httpClient from '../../utils/httpClient'


import CompanyTable from './CompanyTable'
import CompanyFilter from './CompanyFilter'
import CompletitudCalidadGeneral from './CompletitudCalidadGeneral'
import CompletitudInstalaciones from './CompletitudInstalaciones'
import CompletitudCalidadInstalaciones from './CompletitudCalidadInstalaciones'
import { empresasGeneral, reportesService } from '../../services'
import { Dropdown, Icon } from "semantic-ui-react" 
import dataProvider from '../../utils/dataProvider'



const styles = theme => ({
  title : {
    marginBottom: '20px',
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
    fontSize: 23,
    '& svg' : { color: '#019EAC', paddingRight : 10 }
  },
  root: {
    // overflow: 'visible'
  },
  snackbarWarning: {
    backgroundColor: theme.palette.error.light,
  }
})

const iconStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  margin: 'auto',
  right: '2.5em',
  lineHeight: 1,
  zIndex: 1,
}

const containerStyle = {
  position: 'relative',
  display: 'inline-block',
  width: '70vw'
}

class Reportes extends Component {
  constructor(props) {
    super(props)

    this.state = {
      empresa: false,
      currentPage: 1,
      search: "",
      loading: false,
      perPage: 10,
      empresas: [],
      visibleIds: [],
        value: '',


      tipoInstalacion: false,
      tipoInstalacionChoices: [],
      datoTecnico: false,
      datoTecnicoChoices: [],


      sortColumn: "id_empresa",
      sortDirection: "ASC",

      totalResults: 0,

      saving: false,
      snackbarOpen: false,
      dataSetCompletitud: null,
      idEmpresa: null,
        /*
,https://api-infotecnica.coordinador.cl/v1/completitud/general
      dataSetCompletitud: {
        "datos_a_informar":503364,
        "datos_informados":450479,
        "datos_no_informados":52885,
        "completitud":0.89494,
        "fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"
      }
        */
    //https://api-infotecnica.coordinador.cl/v1/completitud/tipo-instalaciones
      /*dataSetCalidadGeneral: {
        "datos_informados":450479,
        "datos_certificados":354582,
        "datos_validados":219056,
        "datos_en_uso":135526,
        "datos_rechazados":49325,
        "datos_no_revisados":46470,
        "calidad":0.78712,
        "fecha_actualizacion":"2021-09-10T11:00:19.673274-03:00"
      },*/
      /*dataSetTipoInstalacion: [
        {
          "id_tipo_instalacion":40019,
          "tipo_instalacion_nombre":"Antecedentes Generales PMGD",
          "registros_informados":538,
          "datos_a_informar":3608,
          "datos_informados":3586,
          "datos_no_informados":22,
          "datos_certificados":3490,
          "datos_validados":1908,
          "datos_en_uso":1582,
          "datos_rechazados":4,
          "datos_no_revisados":92,
          "completitud":0.9939,
          "calidad":0.97323,
          "fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"
        },
        {   
            "id_tipo_instalacion":20,
            "tipo_instalacion_nombre":"Bancos Condensadores",
            "registros_informados":465,
            "datos_a_informar":3089,
            "datos_informados":2712,
            "datos_no_informados":377,
            "datos_certificados":2427,
            "datos_validados":621,
            "datos_en_uso":1806,
            "datos_rechazados":92,
            "datos_no_revisados":193,
            "completitud":0.87795,
            "calidad":0.89491,
            "fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"
        },
        {
            "id_tipo_instalacion":11,
            "tipo_instalacion_nombre":"Barras",
            "registros_informados":2784,"datos_a_informar":10710,
            "datos_informados":8656,
            "datos_no_informados":2054,"datos_certificados":7380,"datos_validados":4910,"datos_en_uso":2470,"datos_rechazados":713,"datos_no_revisados":533,"completitud":0.80822,"calidad":0.85259,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":34,"tipo_instalacion_nombre":"Celdas","registros_informados":24,"datos_a_informar":24,"datos_informados":24,"datos_no_informados":0,"datos_certificados":0,"datos_validados":0,"datos_en_uso":0,"datos_rechazados":0,"datos_no_revisados":24,"completitud":1.0,"calidad":0.0,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":3,"tipo_instalacion_nombre":"Centrales","registros_informados":684,"datos_a_informar":11080,"datos_informados":11022,"datos_no_informados":58,"datos_certificados":10393,"datos_validados":8361,"datos_en_uso":2032,"datos_rechazados":35,"datos_no_revisados":594,"completitud":0.99477,"calidad":0.94293,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":25,"tipo_instalacion_nombre":"Compensadores Activos","registros_informados":5,"datos_a_informar":29,"datos_informados":29,"datos_no_informados":0,"datos_certificados":27,"datos_validados":26,"datos_en_uso":1,"datos_rechazados":0,"datos_no_revisados":2,"completitud":1.0,"calidad":0.93103,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":22,"tipo_instalacion_nombre":"Condensadores Serie","registros_informados":20,"datos_a_informar":139,"datos_informados":139,"datos_no_informados":0,"datos_certificados":137,"datos_validados":93,"datos_en_uso":44,"datos_rechazados":2,"datos_no_revisados":0,"completitud":1.0,"calidad":0.98561,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":23,"tipo_instalacion_nombre":"Condensadores Sincronos","registros_informados":2,"datos_a_informar":12,"datos_informados":12,"datos_no_informados":0,"datos_certificados":8,"datos_validados":5,"datos_en_uso":3,"datos_rechazados":0,"datos_no_revisados":4,"completitud":1.0,"calidad":0.66667,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":5,"tipo_instalacion_nombre":"Configuraciones","registros_informados":654,"datos_a_informar":9093,"datos_informados":6972,"datos_no_informados":2121,"datos_certificados":6137,"datos_validados":4988,"datos_en_uso":1149,"datos_rechazados":66,"datos_no_revisados":769,"completitud":0.76674,"calidad":0.88024,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":32,"tipo_instalacion_nombre":"Desconectadores","registros_informados":13109,"datos_a_informar":25924,"datos_informados":23836,"datos_no_informados":2088,"datos_certificados":19802,"datos_validados":11582,"datos_en_uso":8220,"datos_rechazados":2496,"datos_no_revisados":1538,"completitud":0.91946,"calidad":0.83076,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":30,"tipo_instalacion_nombre":"Dispositivos Reconexion","registros_informados":349,"datos_a_informar":1320,"datos_informados":1289,"datos_no_informados":31,"datos_certificados":1134,"datos_validados":245,"datos_en_uso":889,"datos_rechazados":131,"datos_no_revisados":24,"completitud":0.97652,"calidad":0.87975,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":35,"tipo_instalacion_nombre":"Equipos de Comunicación","registros_informados":312,"datos_a_informar":6185,"datos_informados":4740,"datos_no_informados":1445,"datos_certificados":3900,"datos_validados":3128,"datos_en_uso":772,"datos_rechazados":175,"datos_no_revisados":665,"completitud":0.76637,"calidad":0.82278,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4008,"tipo_instalacion_nombre":"Generadores","registros_informados":762,"datos_a_informar":11637,"datos_informados":10244,"datos_no_informados":1393,"datos_certificados":7214,"datos_validados":3674,"datos_en_uso":3540,"datos_rechazados":2215,"datos_no_revisados":815,"completitud":0.8803,"calidad":0.70422,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":29,"tipo_instalacion_nombre":"Interruptores","registros_informados":8823,"datos_a_informar":70267,"datos_informados":66131,"datos_no_informados":4136,"datos_certificados":53909,"datos_validados":26552,"datos_en_uso":27357,"datos_rechazados":8634,"datos_no_revisados":3588,"completitud":0.94114,"calidad":0.81519,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":33,"tipo_instalacion_nombre":"Medidores","registros_informados":1460,"datos_a_informar":13133,"datos_informados":10936,"datos_no_informados":2197,"datos_certificados":9893,"datos_validados":9890,"datos_en_uso":3,"datos_rechazados":72,"datos_no_revisados":971,"completitud":0.83271,"calidad":0.90463,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4014,"tipo_instalacion_nombre":"Motor de Combustion Interna","registros_informados":367,"datos_a_informar":712,"datos_informados":642,"datos_no_informados":70,"datos_certificados":587,"datos_validados":488,"datos_en_uso":99,"datos_rechazados":1,"datos_no_revisados":54,"completitud":0.90169,"calidad":0.91433,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":28,"tipo_instalacion_nombre":"Pararrayos","registros_informados":1871,"datos_a_informar":7436,"datos_informados":5470,"datos_no_informados":1966,"datos_certificados":4529,"datos_validados":3953,"datos_en_uso":576,"datos_rechazados":461,"datos_no_revisados":480,"completitud":0.73561,"calidad":0.82797,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4015,"tipo_instalacion_nombre":"Planta de Generacion Solar","registros_informados":291,"datos_a_informar":500,"datos_informados":394,"datos_no_informados":106,"datos_certificados":304,"datos_validados":270,"datos_en_uso":34,"datos_rechazados":20,"datos_no_revisados":70,"completitud":0.788,"calidad":0.77157,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":40026,"tipo_instalacion_nombre":"Planta de Generacion Solar PMGD","registros_informados":220,"datos_a_informar":124,"datos_informados":123,"datos_no_informados":1,"datos_certificados":117,"datos_validados":117,"datos_en_uso":0,"datos_rechazados":1,"datos_no_revisados":5,"completitud":0.99194,"calidad":0.95122,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":24,"tipo_instalacion_nombre":"Reactores","registros_informados":126,"datos_a_informar":852,"datos_informados":781,"datos_no_informados":71,"datos_certificados":631,"datos_validados":385,"datos_en_uso":246,"datos_rechazados":109,"datos_no_revisados":41,"completitud":0.91667,"calidad":0.80794,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":9,"tipo_instalacion_nombre":"Secciones Tramos","registros_informados":2128,"datos_a_informar":92067,"datos_informados":83882,"datos_no_informados":8185,"datos_certificados":63109,"datos_validados":18065,"datos_en_uso":45044,"datos_rechazados":10196,"datos_no_revisados":10521,"completitud":0.9111,"calidad":0.75235,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":21,"tipo_instalacion_nombre":"Sistema de Compensación Estática de Reactivos","registros_informados":11,"datos_a_informar":54,"datos_informados":54,"datos_no_informados":0,"datos_certificados":54,"datos_validados":54,"datos_en_uso":0,"datos_rechazados":0,"datos_no_revisados":0,"completitud":1.0,"calidad":1.0,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":26,"tipo_instalacion_nombre":"Sistemas Proteccion","registros_informados":11523,"datos_a_informar":68965,"datos_informados":63941,"datos_no_informados":5024,"datos_certificados":51550,"datos_validados":41292,"datos_en_uso":10258,"datos_rechazados":6096,"datos_no_revisados":6295,"completitud":0.92715,"calidad":0.80621,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":10,"tipo_instalacion_nombre":"Subestaciones","registros_informados":1108,"datos_a_informar":18823,"datos_informados":17984,"datos_no_informados":839,"datos_certificados":15743,"datos_validados":14433,"datos_en_uso":1310,"datos_rechazados":1339,"datos_no_revisados":902,"completitud":0.95543,"calidad":0.87539,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":31,"tipo_instalacion_nombre":"Trampas Ondas","registros_informados":254,"datos_a_informar":762,"datos_informados":711,"datos_no_informados":51,"datos_certificados":535,"datos_validados":444,"datos_en_uso":91,"datos_rechazados":91,"datos_no_revisados":85,"completitud":0.93307,"calidad":0.75246,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":16,"tipo_instalacion_nombre":"Transformadores 2D","registros_informados":1755,"datos_a_informar":49654,"datos_informados":45359,"datos_no_informados":4295,"datos_certificados":28685,"datos_validados":25090,"datos_en_uso":3595,"datos_rechazados":8112,"datos_no_revisados":8549,"completitud":0.9135,"calidad":0.6324,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":17,"tipo_instalacion_nombre":"Transformadores 3D","registros_informados":337,"datos_a_informar":15241,"datos_informados":12198,"datos_no_informados":3043,"datos_certificados":7916,"datos_validados":7871,"datos_en_uso":45,"datos_rechazados":2777,"datos_no_revisados":1502,"completitud":0.80034,"calidad":0.64896,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":18,"tipo_instalacion_nombre":"Transformadores Corriente","registros_informados":8899,"datos_a_informar":43074,"datos_informados":37297,"datos_no_informados":5777,"datos_certificados":28323,"datos_validados":17431,"datos_en_uso":10892,"datos_rechazados":3616,"datos_no_revisados":5358,"completitud":0.86588,"calidad":0.75939,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":19,"tipo_instalacion_nombre":"Transformadores Potencial","registros_informados":3991,"datos_a_informar":23459,"datos_informados":17357,"datos_no_informados":6102,"datos_certificados":14390,"datos_validados":8262,"datos_en_uso":6128,"datos_rechazados":1034,"datos_no_revisados":1933,"completitud":0.73989,"calidad":0.82906,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4011,"tipo_instalacion_nombre":"Turbina a Gas","registros_informados":77,"datos_a_informar":777,"datos_informados":534,"datos_no_informados":243,"datos_certificados":347,"datos_validados":170,"datos_en_uso":177,"datos_rechazados":104,"datos_no_revisados":83,"completitud":0.68726,"calidad":0.64981,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4012,"tipo_instalacion_nombre":"Turbinas a Vapor","registros_informados":49,"datos_a_informar":1155,"datos_informados":998,"datos_no_informados":157,"datos_certificados":649,"datos_validados":286,"datos_en_uso":363,"datos_rechazados":146,"datos_no_revisados":203,"completitud":0.86407,"calidad":0.6503,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4013,"tipo_instalacion_nombre":"Turbinas Eolicas","registros_informados":46,"datos_a_informar":280,"datos_informados":189,"datos_no_informados":91,"datos_certificados":165,"datos_validados":128,"datos_en_uso":37,"datos_rechazados":21,"datos_no_revisados":3,"completitud":0.675,"calidad":0.87302,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":40024,"tipo_instalacion_nombre":"Turbinas Eolicas PMGD","registros_informados":7,"datos_a_informar":7,"datos_informados":7,"datos_no_informados":0,"datos_certificados":7,"datos_validados":0,"datos_en_uso":7,"datos_rechazados":0,"datos_no_revisados":0,"completitud":1.0,"calidad":1.0,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4010,"tipo_instalacion_nombre":"Turbinas Hidraulicas","registros_informados":271,"datos_a_informar":3437,"datos_informados":2746,"datos_no_informados":691,"datos_certificados":2083,"datos_validados":765,"datos_en_uso":1318,"datos_rechazados":457,"datos_no_revisados":206,"completitud":0.79895,"calidad":0.75856,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"},{"id_tipo_instalacion":4002,"tipo_instalacion_nombre":"Unidades Generadoras (General)","registros_informados":1101,"datos_a_informar":9735,"datos_informados":9484,"datos_no_informados":251,"datos_certificados":9007,"datos_validados":3569,"datos_en_uso":5438,"datos_rechazados":109,"datos_no_revisados":368,"completitud":0.97422,"calidad":0.9497,"fecha_actualizacion":"2021-09-10T11:00:19.673091-03:00"}]
        */
    }

    this.fetchResults = this.fetchResults.bind(this);
    this.debouncedThing = _.debounce(this.doTheThing, 1000)
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerPageChange = this.handlePerPageChange.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handleChange = this.handleChange.bind(this)
  }

    /*
    {
        "tipo_instalacion_nombre": "Aisladores",
        "datos_en_uso": 2,
        "datos_informados": 13433,
        "datos_no_revisados": 74703,
        "datos_rechazados": 0,
        "datos_validados": 7,
        "datos_certificados": 9,
        "datos_a_informar": 74712,
        "calidad": 0.06699918112111963
    }

    {
        "tipo_instalacion": "Líneas",
        "datos_a_informar": 150,
        "datos_informados": 15,
        "datos_no_informados": 135,
        "completitud": 10.0
    }
    */

    componentDidMount() {
        
        const filterParams = {
        pagination: {
            page: 1,
            perPage: 10,
        },
        sort: { field: 'id_empresa', order: 'ASC' },
        filter: { search: '' }
        }


        this.setState({ loading: true })
        reportesService.empresasGeneral(filterParams)
        .then(({ empresas, totalResults }) => {
            this.setState({ empresas, totalResults,  loading: false })
        })
        .catch( error => { 
            console.log(error) 
            throw error
        })

        this.setState({ loading: true })
        reportesService.empresasGeneralCompanyFilter()
        .then(({ empresas }) => {
            let arr = []
            empresas.forEach( (x, i, v) =>  {
                const { id_empresa, nombre_empresa, datos_a_informar, datos_informados, datos_no_informados, datos_certificados, completitud, calidad } = x

                let obj = { key: id_empresa, value: nombre_empresa, text: nombre_empresa }
                arr.push(obj)
            })

            this.setState({ empresasList: arr })
        })
        .catch( error => { 
            console.log(error) 
            throw error
        })

        
        this.setState({ isPendingCompletitud: true })
        reportesService.completitudGeneral()
            .then(( dataSetCompletitud ) => { 
                this.setState({ dataSetCompletitud, isPendingCompletitud: false })
            })
            .catch( error => { 
                console.log(error) 
                throw error
        })

        this.setState({ isPendingCalidadGeneral: true })
        reportesService.calidadGeneral()
            .then(( dataSetCalidadGeneral ) => { 
                this.setState({ dataSetCalidadGeneral, isPendingCalidadGeneral: false })
            })
            .catch( error => { 
                console.log(error) 
                throw error
        })


        this.setState({ isPendingCalidadTipoInstalacion: true })
        reportesService.calidadTipoInstalacion()
            .then(( dataSetTipoInstalacion ) => { 
                this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
            })
            .catch( error => { 
                console.log(error) 
                throw error
        })

        this.setState({ isPendingCompletitudTipoInstalacion: true })
        reportesService.completitudTipoInstalacion()
            .then(( dataSetCompletitudTipoInstalacion ) => {
                this.setState({ dataSetCompletitudTipoInstalacion, isPendingCompletitudTipoInstalacion: false })
            })
            .catch( error => { 
                console.log(error) 
                throw error
        })

    }

    componentDidUpdate( nextProps, nextState, snapshot ) {
        if(this.state.value != nextState.value)
        {
            if(this.state.value == ''){
                this.setState({ idEmpresa: null })
                this.setState({ isPendingCompletitud: true })
                reportesService.completitudGeneral()
                .then(( dataSetCompletitud ) => { 
                    this.setState({ dataSetCompletitud, isPendingCompletitud: false })
                })
                .catch( error => { 
                    console.log(error) 
                    throw error
                })

                this.setState({ isPendingCalidadGeneral: true })
                        reportesService.calidadGeneral()
                            .then(( dataSetCalidadGeneral ) => { 
                                this.setState({ dataSetCalidadGeneral, isPendingCalidadGeneral: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })

                this.setState({ isPendingCalidadTipoInstalacion: true })
                        reportesService.calidadTipoInstalacion()
                            .then(( dataSetTipoInstalacion ) => { 
                                this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })

                this.setState({ isPendingCompletitudTipoInstalacion: true })
                        reportesService.completitudTipoInstalacion()
                            .then(( dataSetCompletitudTipoInstalacion ) => { 
                                this.setState({ dataSetCompletitudTipoInstalacion, isPendingCompletitudTipoInstalacion: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })

            
            }
            else 
            {
                let id
                this.state.empresasList.forEach((x, i, v) => {
                    const { key, value} = x 
                    if(this.state.value == value)
                    {
                        id = key
                        this.setState({ idEmpresa: id })
                    }
                })

                this.setState({ loading: true })
                reportesService.empresasGeneralCompanyId(id)
                .then(({ empresas, totalResults }) => {
                    this.setState({ empresas, totalResults,  loading: false })
                })
                .catch( error => { 
                    console.log(error) 
                    throw error
                })

                this.setState({ isPendingCompletitud: true })
                reportesService.completitudGeneral(id)
                    .then(( dataSetCompletitud ) => { 
                        this.setState({ dataSetCompletitud, isPendingCompletitud: false })
                    })
                    .catch( error => { 
                        console.log(error) 
                        throw error
                })


                this.setState({ isPendingCalidadGeneral: true })
                        reportesService.calidadGeneral(id)
                            .then(( dataSetCalidadGeneral ) => { 
                                this.setState({ dataSetCalidadGeneral, isPendingCalidadGeneral: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })

                this.setState({ isPendingCalidadTipoInstalacion: true })
                        reportesService.calidadTipoInstalacion(id)
                            .then(( dataSetTipoInstalacion ) => { 
                                this.setState({ dataSetTipoInstalacion, isPendingCalidadTipoInstalacion: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })

                this.setState({ isPendingCompletitudTipoInstalacion: true })
                        reportesService.completitudTipoInstalacion(id)
                            .then(( dataSetCompletitudTipoInstalacion ) => {
                                this.setState({ dataSetCompletitudTipoInstalacion, isPendingCompletitudTipoInstalacion: false })
                            })
                            .catch( error => { 
                                console.log(error) 
                                throw error
                        })    
            }
        }
    }

   handlePerPageChange(newPerPage) {
    this.setState({
      perPage: newPerPage,
      visibleIds: []
    }, () => this.fetchResults())
   }

  handleSearchChange = () => (event, value) => {
    this.debouncedThing(value.searchQuery)
  }

    handleChange = () => (event, value) => {
        this.setState({ value: value.value })
        //this.debouncedThing(value.value)
    }

   

    handleClear() {
        this.setState({ value: '' }, () => {
            this.debouncedThing(this.state.value)
        })
    }

  doTheThing(value) {
    this.setState({
      search: value,
      totalResults: 0,
      currentPage: 1,
    }, () => this.fetchResults())
  }

    fetchResults() {
        const {
        search
        } = this.state
        const filter = {};
        if (!!search) { filter["search"] = search }
        const filterParams = {
        pagination: {
            page: this.state.currentPage,
            perPage: this.state.perPage,
        },
        sort: {
            field: this.state.sortColumn,
            order: this.state.sortDirection
        },
        filter
        }

        this.setState({ loading: true })
        reportesService.empresasGeneral(filterParams)
        .then( ({ empresas, totalResults }) => { 
            this.setState({ empresas, totalResults,  loading: false })
        })
    
    }

  handlePageChange(newPage) {
    this.setState({ currentPage: newPage }, () => this.fetchResults())
  }

  render() {
    const { dataSetCalidadGeneral, dataSetCompletitud, dataSetTipoInstalacion, dataSetCompletitudTipoInstalacion, empresas } = this.state
    const { classes } = this.props
    
    return (
      <Authenticated
        authParams={{ required: false, roles: ["admin", "coordinador", "externo", "coordinado"] }}
        location={this.props.location}
      >
        
          <Card className={classes.root}>
            <CardContent>
              <Typography className={classes.title}>
                <CertificationIcon /> Reportes Empresas
              </Typography>
                <Grid>              
                    <CompanyFilter
                        value={this.state.value}
                        options = {this.state.empresasList}
                        handleSearchChange = {this.handleSearchChange}
                        handleChange = {this.handleChange}
                        handleClear = {this.handleClear}
                    />
                </Grid>
              <Grid>
                <Grid>
                  <CompanyTable
                    empresas={this.state.empresas}
                    id={this.state.idEmpresa}
                    total={this.state.totalResults}
                    page={this.state.currentPage}
                    perPage={this.state.perPage}
                    isLoading={this.state.loading}
                    onPageChange={this.handlePageChange}
                    onPerPageChange={this.handlePerPageChange}
                    value={this.state.value}
                  />
                </Grid>
                 {/* Completitud y Calidad General */}
                <Grid container spacing={8}>
                  <Grid item xs={12} md={6}>
                    {dataSetCompletitud && <CompletitudCalidadGeneral 
                      type='completitud' 
                      dataset={{
                        isPending: this.state.isPendingCompletitud,
                        data: dataSetCompletitud
                      }} />}
                  </Grid>
                  <Grid item xs={12} md={6} >
                    <CompletitudCalidadGeneral 
                      type='calidad'
                      dataset={{
                        isPending: this.state.isPendingCalidadGeneral,
                        data: dataSetCalidadGeneral
                     }} />
                  </Grid>
                </Grid>
                <Grid>
                  {dataSetCompletitudTipoInstalacion && <CompletitudCalidadInstalaciones type='completitud'
                    dataset={{
                      isPending: this.state.isPendingCompletitudTipoInstalacion,
                      data: dataSetCompletitudTipoInstalacion
                    }}
                  />}
                </Grid>
                <Grid>
                  {dataSetTipoInstalacion && <CompletitudInstalaciones
                    divId={'completitud-tipo-instalacion-general'}
                    title={"Calidad General por Tipo de Instalación"}
                    dataset={{
                      isPending: this.state.isPendingCalidadTipoInstalacion,
                      data: dataSetTipoInstalacion
                    }}
                  />}
                </Grid>
              </Grid>
            </CardContent>
          </Card>
      </Authenticated>
    )
  }
}

export default withRouter(withStyles(styles)(Reportes))
